import React from "react";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "../../../design/dropdown";
import { View } from "react-big-calendar";
import {
  CalendarDaysIcon,
  CalendarIcon,
  ClockIcon,
  ListBulletIcon
} from "@heroicons/react/24/outline";

interface SelectViewComponentProps {
  currentView: View;
  onView: (view: View) => void;
}

const SelectViewComponent: React.FC<SelectViewComponentProps> = ({
  currentView,
  onView,
}) => {
  const getViewIcon = (view: string) => {
    switch (view) {
      case "day":
        return <CalendarIcon className="w-4 h-4" />;
      case "week":
        return <CalendarDaysIcon className="w-4 h-4" />;
      case "month":
        return <CalendarIcon className="w-4 h-4" />;
      case "agenda":
        return <ListBulletIcon className="w-4 h-4" />;
      default:
        return <ClockIcon className="w-4 h-4" />;
    }
  };

  const getViewLabel = (view: string) => {
    switch (view) {
      case "day":
        return "Day";
      case "week":
        return "Week";
      case "month":
        return "Month";
      case "agenda":
        return "Agenda";
      default:
        return "Day";
    }
  };

  const viewOptions: { value: View; label: string; icon: React.ReactNode }[] = [
    { value: "day", label: "Day", icon: <CalendarIcon className="w-4 h-4" /> },
    { value: "week", label: "Week", icon: <CalendarDaysIcon className="w-4 h-4" /> },
    { value: "month", label: "Month", icon: <CalendarIcon className="w-4 h-4" /> },
    { value: "agenda", label: "Agenda", icon: <ListBulletIcon className="w-4 h-4" /> },
  ];

  return (
    <Dropdown>
      <DropdownButton
        outline
        className="flex items-center gap-2"
        aria-label={`Current view: ${getViewLabel(currentView)}`}
      >
        {getViewIcon(currentView)}
        <span>{getViewLabel(currentView)}</span>
      </DropdownButton>
      <DropdownMenu>
        {viewOptions.map((option) => (
          <DropdownItem
            key={option.value}
            onClick={() => onView(option.value)}
            className={`flex items-center gap-2 ${
              currentView === option.value ? 'bg-blue-50 dark:bg-blue-900/20' : ''
            }`}
          >
            {option.icon}
            <span>{option.label}</span>
            {currentView === option.value && (
              <span className="ml-auto text-blue-600 dark:text-blue-400">✓</span>
            )}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default SelectViewComponent;
